import {
  insertMoods,
  getUserMoods,
  selectMood,
  getAllMoodsByUserId,
  deleteMood,
  getMoodAnalytics,
} from '../util/api';

export const INSERT_MOODS_REQUEST = 'app/moods/INSERT_MOODS_REQUEST';
export const INSERT_MOODS_SUCCESS = 'app/moods/INSERT_MOODS_SUCCESS';
export const INSERT_MOODS_ERROR = 'app/moods/INSERT_MOODS_ERROR';

export const FETCH_MOODS_REQUEST = 'app/moods/FETCH_MOODS_REQUEST';
export const FETCH_MOODS_SUCCESS = 'app/moods/FETCH_MOODS_SUCCESS';
export const FETCH_MOODS_ERROR = 'app/moods/FETCH_MOODS_ERROR';

export const SELECT_MOOD_REQUEST = 'app/moods/SELECT_MOOD_REQUEST';
export const SELECT_MOOD_SUCCESS = 'app/moods/SELECT_MOOD_SUCCESS';
export const SELECT_MOOD_ERROR = 'app/moods/SELECT_MOOD_ERROR';

export const FETCH_ALL_MOODS_REQUEST = 'app/moods/FETCH_ALL_MOODS_REQUEST';
export const FETCH_ALL_MOODS_SUCCESS = 'app/moods/FETCH_ALL_MOODS_SUCCESS';
export const FETCH_ALL_MOODS_ERROR = 'app/moods/FETCH_ALL_MOODS_ERROR';

export const DELETE_MOOD_REQUEST = 'app/moods/DELETE_MOOD_REQUEST';
export const DELETE_MOOD_SUCCESS = 'app/moods/DELETE_MOOD_SUCCESS';
export const DELETE_MOOD_ERROR = 'app/moods/DELETE_MOOD_ERROR';

export const FETCH_MOOD_ANALYTICS_REQUEST = 'app/moods/FETCH_MOOD_ANALYTICS_REQUEST';
export const FETCH_MOOD_ANALYTICS_SUCCESS = 'app/moods/FETCH_MOOD_ANALYTICS_SUCCESS';
export const FETCH_MOOD_ANALYTICS_ERROR = 'app/moods/FETCH_MOOD_ANALYTICS_ERROR';

export const initialState = {
  isSubmitting: false,
  submitSuccess: false,
  error: null,
  moods: [],
  isFetching: false,
  fetchError: null,
  isSelectingMood: false,
  selectMoodSuccess: false,
  selectMoodError: null,
  selectMoodMessage: null,
  allMoods: [],
  isFetchingAllMoods: false,
  fetchAllMoodsError: null,
  isDeletingMood: false,
  deleteMoodSuccess: false,
  deleteMoodError: null,
  moodAnalytics: null,
  isFetchingMoodAnalytics: false,
  fetchMoodAnalyticsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case INSERT_MOODS_REQUEST:
      return { ...state, isSubmitting: true, error: null };
    case INSERT_MOODS_SUCCESS:
      return { ...state, isSubmitting: false, submitSuccess: true, error: null };
    case INSERT_MOODS_ERROR:
      return { ...state, isSubmitting: false, submitSuccess: false, error: payload };
    case FETCH_MOODS_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_MOODS_SUCCESS:
      return { ...state, isFetching: false, moods: payload, fetchError: null };
    case FETCH_MOODS_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    case SELECT_MOOD_REQUEST:
      return { ...state, isSelectingMood: true, selectMoodError: null, selectMoodMessage: null };
    case SELECT_MOOD_SUCCESS:
      return {
        ...state,
        isSelectingMood: false,
        selectMoodSuccess: true,
        selectMoodError: null,
        selectMoodMessage: payload.message,
      };
    case SELECT_MOOD_ERROR:
      return {
        ...state,
        isSelectingMood: false,
        selectMoodSuccess: false,
        selectMoodError: payload,
      };
    case FETCH_ALL_MOODS_REQUEST:
      return { ...state, isFetchingAllMoods: true, fetchAllMoodsError: null };
    case FETCH_ALL_MOODS_SUCCESS:
      return { ...state, isFetchingAllMoods: false, allMoods: payload, fetchAllMoodsError: null };
    case FETCH_ALL_MOODS_ERROR:
      return { ...state, isFetchingAllMoods: false, fetchAllMoodsError: payload };
    case DELETE_MOOD_REQUEST:
      return { ...state, isDeletingMood: true, deleteMoodError: null };
    case DELETE_MOOD_SUCCESS:
      return { ...state, isDeletingMood: false, deleteMoodSuccess: true, deleteMoodError: null };
    case DELETE_MOOD_ERROR:
      return {
        ...state,
        isDeletingMood: false,
        deleteMoodSuccess: false,
        deleteMoodError: payload,
      };
    case FETCH_MOOD_ANALYTICS_REQUEST:
      return { ...state, isFetchingMoodAnalytics: true, fetchMoodAnalyticsError: null };
    case FETCH_MOOD_ANALYTICS_SUCCESS:
      return {
        ...state,
        isFetchingMoodAnalytics: false,
        moodAnalytics: payload,
        fetchMoodAnalyticsError: null,
      };
    case FETCH_MOOD_ANALYTICS_ERROR:
      return { ...state, isFetchingMoodAnalytics: false, fetchMoodAnalyticsError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const insertMoodsRequest = () => ({ type: INSERT_MOODS_REQUEST });
export const insertMoodsSuccess = () => ({ type: INSERT_MOODS_SUCCESS });
export const insertMoodsError = error => ({ type: INSERT_MOODS_ERROR, payload: error });

export const fetchMoodsRequest = () => ({ type: FETCH_MOODS_REQUEST });
export const fetchMoodsSuccess = moods => ({ type: FETCH_MOODS_SUCCESS, payload: moods });
export const fetchMoodsError = error => ({ type: FETCH_MOODS_ERROR, payload: error });

export const selectMoodRequest = () => ({ type: SELECT_MOOD_REQUEST });
export const selectMoodSuccess = response => ({ type: SELECT_MOOD_SUCCESS, payload: response });
export const selectMoodError = error => ({ type: SELECT_MOOD_ERROR, payload: error });

export const fetchAllMoodsRequest = () => ({ type: FETCH_ALL_MOODS_REQUEST });
export const fetchAllMoodsSuccess = moods => ({ type: FETCH_ALL_MOODS_SUCCESS, payload: moods });
export const fetchAllMoodsError = error => ({ type: FETCH_ALL_MOODS_ERROR, payload: error });

export const deleteMoodRequest = () => ({ type: DELETE_MOOD_REQUEST });
export const deleteMoodSuccess = () => ({ type: DELETE_MOOD_SUCCESS });
export const deleteMoodError = error => ({ type: DELETE_MOOD_ERROR, payload: error });

export const fetchMoodAnalyticsRequest = () => ({ type: FETCH_MOOD_ANALYTICS_REQUEST });
export const fetchMoodAnalyticsSuccess = analytics => ({
  type: FETCH_MOOD_ANALYTICS_SUCCESS,
  payload: analytics,
});
export const fetchMoodAnalyticsError = error => ({
  type: FETCH_MOOD_ANALYTICS_ERROR,
  payload: error,
});

// ================ Thunks ================ //

export const insertMoodsData = state => {
  return {
    isSubmitting: state.moods.isSubmitting,
    submitSuccess: state.moods.submitSuccess,
    error: state.moods.error,
  };
};

export const fetchMoodsData = state => {
  return {
    moods: state.moods.moods,
    isFetching: state.moods.isFetching,
    fetchError: state.moods.fetchError,
  };
};

export const selectMoodData = state => {
  return {
    isSelectingMood: state.moods.isSelectingMood,
    selectMoodSuccess: state.moods.selectMoodSuccess,
    selectMoodError: state.moods.selectMoodError,
    selectMoodMessage: state.moods.selectMoodMessage,
  };
};

export const fetchAllMoodsData = state => {
  return {
    allMoods: state.moods.allMoods,
    isFetchingAllMoods: state.moods.isFetchingAllMoods,
    fetchAllMoodsError: state.moods.fetchAllMoodsError,
  };
};

export const deleteMoodData = state => {
  return {
    isDeletingMood: state.moods.isDeletingMood,
    deleteMoodSuccess: state.moods.deleteMoodSuccess,
    deleteMoodError: state.moods.deleteMoodError,
  };
};

export const fetchMoodAnalyticsData = state => {
  return {
    moodAnalytics: state.moods.moodAnalytics,
    isFetchingMoodAnalytics: state.moods.isFetchingMoodAnalytics,
    fetchMoodAnalyticsError: state.moods.fetchMoodAnalyticsError,
  };
};

export const insertMoodsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(insertMoodsRequest());
  try {
    const result = await insertMoods(params);
    dispatch(insertMoodsSuccess());
    return result;
  } catch (error) {
    console.error('Error inserting moods:', error);
    dispatch(insertMoodsError(error.message || 'Failed to submit moods'));
    throw error;
  }
};

export const fetchMoodsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchMoodsRequest());
  try {
    const result = await getUserMoods(params);
    dispatch(fetchMoodsSuccess(result.moods || []));
    return result;
  } catch (error) {
    console.error('Error fetching moods:', error);
    dispatch(fetchMoodsError(error.message || 'Failed to fetch moods'));
    throw error;
  }
};

export const selectMoodAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(selectMoodRequest());
  try {
    const result = await selectMood(params);
    dispatch(selectMoodSuccess(result));
    return result;
  } catch (error) {
    console.error('Error selecting mood:', error);
    dispatch(selectMoodError(error.message || 'Failed to select mood'));
    throw error;
  }
};

export const fetchAllMoodsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchAllMoodsRequest());
  try {
    const result = await getAllMoodsByUserId(params);
    dispatch(fetchAllMoodsSuccess(result.moods || []));
    return result;
  } catch (error) {
    console.error('Error fetching all moods:', error);
    dispatch(fetchAllMoodsError(error.message || 'Failed to fetch all moods'));
    throw error;
  }
};

export const deleteMoodAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(deleteMoodRequest());
  try {
    const result = await deleteMood(params);
    dispatch(deleteMoodSuccess());
    // Refresh the moods list after successful deletion
    const { userId, date } = params;
    if (userId) {
      dispatch(fetchAllMoodsAction({ userId }));

      // If the deleted mood was for today, also refresh today's mood data for SectionMood
      const today = new Date().toISOString().split('T')[0];
      if (date === today) {
        dispatch(fetchMoodsAction({ userId, startDate: today, endDate: today }));
      }
    }
    return result;
  } catch (error) {
    console.error('Error deleting mood:', error);
    dispatch(deleteMoodError(error.message || 'Failed to delete mood'));
    throw error;
  }
};

export const fetchMoodAnalyticsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchMoodAnalyticsRequest());
  try {
    const result = await getMoodAnalytics(params);
    dispatch(fetchMoodAnalyticsSuccess(result));
    return result;
  } catch (error) {
    console.error('Error fetching mood analytics:', error);
    dispatch(fetchMoodAnalyticsError(error.message || 'Failed to fetch mood analytics'));
    throw error;
  }
};
